<template>
  <div class="table-wrapper">
    <sb-table :column-definitions="columnDefs" :rows="rows">
      <sb-table-thead slot="sb-table-header" slot-scope="{cols}">
        <sb-table-head v-if="false">
          {{ cols[0].name }}
        </sb-table-head>
        <sb-table-head>
          {{ cols[1].name }}
          <img src="@assets/images/info.svg" alt="info" style="margin:0 0 3px 2px;">
        </sb-table-head>
        <sb-table-head v-if="false">
          {{ cols[2].name }}
        </sb-table-head>
        <sb-table-head v-if="false">
          {{ cols[5].name }}
        </sb-table-head>
        <sb-table-head>
          {{ cols[6].name }}
          <img src="@assets/images/info.svg" alt="info" style="margin:0 0 3px 2px;">
        </sb-table-head>
        <sb-table-head v-if="false">
          {{ cols[7].name }}
        </sb-table-head>
        <sb-table-head>
          {{ cols[8].name }}
          <img src="@assets/images/info.svg" alt="info" style="margin:0 0 3px 2px;">
        </sb-table-head>
        <sb-table-head v-if="showActions">
          {{ cols[9].name }}
        </sb-table-head>
      </sb-table-thead>
      <sb-table-row slot="sb-table-row" slot-scope="{row}">
        <sb-table-cell v-if="false">
          {{ row.Country.Id }}
        </sb-table-cell>
        <sb-table-cell v-if="row.Country.Id === homeCountryCurrency.countryCode">
          <span>{{ `${row.Country.Name} (${homeCountryCurrency.currencySymbol}${homeCountryCurrency.currencyCode})` }}</span>
          <span class="hometag">HOME</span>
        </sb-table-cell>
        <sb-table-cell v-else>
          {{ row.Country.Name }}
        </sb-table-cell>
        <sb-table-cell v-if="false">
          {{ row.PricingRegion.Id }}
        </sb-table-cell>
        <sb-table-cell v-if="false">
          {{ row.DomesticPlan.Id }}
        </sb-table-cell>
        <sb-table-cell>{{ row.DomesticPlan.Name }}</sb-table-cell>
        <sb-table-cell v-if="false">
          {{ row.InternationalPlan.Id }}
        </sb-table-cell>
        <sb-table-cell>{{ row.InternationalPlan.Name }}</sb-table-cell>
        <sb-table-cell v-if="showActions" class="edit-action">
          <sb-action-list
            v-if="homeCountryCurrency.countryCode === 'US'"
            id="plan-actions"
            variation="secondary"
            placement="end"
            :actions="actions"
            class="plan-details__action"
            @onAction="handleActionFired($event, row)"
          >
            ...
            <sb-actions slot="actions">
              <sb-action
                v-if="!action.hide"
                :key="action.name"
                slot-scope="{ action }"
                :value="action"
                :disabled="action.disabled || (action.type === 'SetHomeCountry' && row.Country.Id === homeCountryCurrency.countryCode)"
              >
                {{ action.name }}
              </sb-action>
            </sb-actions>
          </sb-action-list>
          <a v-else href="#" :class="{disabled: row.Country.Id !== homeCountryCurrency.countryCode}" @click.prevent="handleEditPricingPlan(IsMerchantPlusView, row)">Edit Plans</a>
        </sb-table-cell>
      </sb-table-row>
    </sb-table>
  </div>
</template>
<script>

export default {
  name: 'UserHomeAndPlanAssignmentTable',
  directives: {},
  filters: {},
  mixins: [],
  props: {
    rows: {
      type: Array,
      default: () => ([])
    },
    showActions: {
      type: Boolean,
      default: true
    },
    isMerchantPlusView: {
      type: Boolean,
      default: false
    },
    homeCountryCurrency: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    columnDefs: [
      { name: 'CountryId', field: 'coutryid' },
      { name: 'Country', field: 'coutryname' },
      { name: 'Pricing Region Id', field: 'pricingregionid' },
      { name: 'Network Pricing', field: 'pricingregionname' },
      { name: 'Merchant+ Locations', field: 'merchantpluslocations' },
      { name: 'DomestiPlanId', field: 'domesticplanid' },
      { name: 'Domestic Plan', field: 'domesticplanname' },
      { name: 'International Plan Id', field: 'internationplannameid' },
      { name: 'International Plan', field: 'internationplanname' },
      { name: 'Action', field: 'action' }
    ],
    showActionOptions: false,
    actions: [
      {
        type: 'EditPlans',
        name: 'Edit Plans',
        disabled: false
      },
      {
        type: 'SetHomeCountry',
        name: 'Set as Home Country',
        disabled: false
      }
    ]
  }),
  computed: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    handleEditPricingPlan (isMerchantPlusView, row) {
      this.$emit('handleEditPricingPlan', isMerchantPlusView, row)
    },
    toggleShowActionOptions () {
      this.showActionOptions = true
    },
    handleSwitchHomeCountryModalOpen (row) {
      this.$emit('handleSwitchHomeCountryModalOpen', row)
    },
    handleActionFired (action, row) {
      if (action.type === 'EditPlans') {
        this.handleEditPricingPlan(false, row)
      } else if (action.type === 'SetHomeCountry') {
        this.handleSwitchHomeCountryModalOpen(row)
      }
    }
  }
}
</script>
<style scoped>

.table-wrapper::v-deep .table {
  margin-bottom: 1.2rem !important;
}
.table th {
  font-size: 0.875rem;
}
.table thead {
  height: 3rem;
}
.table thead th {
  vertical-align: middle;
  color: #343E4F;
}
.table tbody tr td {
  height: 50px;
}
.sb-table-row:has(.sb-action-list.active) {
  background-color: #E5EEF5
}
.sb-table-row:hover {
  background: #fafafa;
}
.edit-action a {
  font-weight: 600;
  text-decoration: none;
}
.sb-action-list::v-deep .btn {
  background: none;
  color: #2470AF;
  border: none;
  box-shadow: none;
}
.sb-action-list::v-deep .btn i {
  display: none;
}
.sb-action-list::v-deep .btn:hover {
  background-color: transparent;
  border-color: transparent;
  font-weight: bolder;
}
.sb-action-list::v-deep .btn:focus {
  box-shadow: none;
  font-weight: bolder;
}
.sb-action-list::v-deep .options-popover {
  top: -68px !important;
  left: -40px !important;
}

.sb-action {
  font-weight: 600;
}

.hometag {
  font-style: normal;
  font-weight: 500;
  font-variant: small-caps;
  color: #2470AF;
  background: rgba(36, 112, 175, 0.08);
  border-radius: 2px;
  padding: 3px;
  font-size: 0.7rem;
}

a.disabled {
  pointer-events: none;
  cursor: default;
  color: #92B8D7;
}
</style>
